type GetFormatedPrice = (value: number | string) => string;

export const getFormatedPrice: GetFormatedPrice = value => {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  return typeof value === 'string'
    ? `$${parseFloat(value).toFixed(2)}`
    : `$${(value / 100).toFixed(2)}`;
};
